import React from "react";
import { Col, Row, Breadcrumb } from "react-bootstrap";
import Footer from "../components/Footer";
import Product from "../products/Product";
import Courses from "../data";

const Shop = () => {
  return (
    <>
      <Row className="mx-0 all-courses">
        <Col className="d-flex align-items-center py-2">
          <Breadcrumb>
            <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Shop</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row className="mx-0 all-courses">
        <Col>
          <Row className="mx-0 pb-4">
            {Courses.map((course, index) => {
              return (
                <Col md={3} className="px-1" key={index}>
                  <Product details={course} />
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Footer />
    </>
  );
};

export default Shop;
